import { render, staticRenderFns } from "./MileageRule.vue?vue&type=template&id=296b6f4f&scoped=true"
import script from "./MileageRule.vue?vue&type=script&setup=true&lang=js"
export * from "./MileageRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MileageRule.vue?vue&type=style&index=0&id=296b6f4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296b6f4f",
  null
  
)

export default component.exports